import * as React from 'react';

import classnames from 'classnames';

import {colors} from 'shells/colors/colors';
import {ContactIcon} from 'shells/icon/svg/contact-icon';

import styles from './rows.module.css';

type Props = {
    sendFromUser:
        | {
              name: string;
          }
        | null
        | undefined;
};

export function SendFrom(props: Props) {
    return (
        <div className={classnames('flex', styles.row)}>
            <div className={styles['line-icon']}>
                {/* @ts-expect-error */}
                <ContactIcon fill={colors.greyLt} size={12} />
            </div>
            {props.sendFromUser ? (
                <span>
                    Send from <strong>{props.sendFromUser.name}</strong>
                </span>
            ) : (
                <span>Send from the lead assignee</span>
            )}
        </div>
    );
}
